import { DeleteLinkButton, OverviewHeader } from "../../../../../../components";
import { AddToPacksButton } from "../../../../../../components/buttons/AddToPacksButton/AddToPacksButton";
import { ToggleVisibilityButton } from "../../../../../../components/buttons/linkButtons/toggleVisibilityButton/ToggleVisibilityButton";
import { Tooltip } from "../../../../../../components/common/tooltip";
import AddAssetsToPackModal from "../../../../../../components/modal/AddAssetsToPacksModal/AddAssetsToPackModal";
import { RolePermissions, Strings } from "../../../../../../enums";
import Restricted from "../../../../../Application/Restricted";
import useToggle from "../../../../../../hooks/useToggle";
import { Icon } from "semantic-ui-react";
import TagsManageContainer from "./TagsManageContainer";
import { CreateButton } from "../CreateButton";

import styles from "./OverviewHeader.module.scss";

export interface OverviewHeaderProps {
  selectedIds: number[];
  purchasedSelected: boolean;
  draftSelected: boolean;
  hiddenSelected: boolean;
  visibleSelected: boolean;
  clearSelection: () => void;
  handleDelete: (selectedIds: number[], flowsCount?: number, packsCount?: number) => void;
  handleToggleVisibility: (selectedIds: number[], hidden: boolean) => () => void;
}

export const ScormOverviewHeader = (props: OverviewHeaderProps) => {
  const {
    purchasedSelected,
    draftSelected,
    selectedIds,
    clearSelection,
    handleDelete,
    handleToggleVisibility,
    hiddenSelected,
    visibleSelected,
  } = props;

  const [packsModalShown, togglePackModal] = useToggle();
  const visibility = !(visibleSelected && hiddenSelected) && purchasedSelected;

  const message = Strings.tooltipMessages.purchased.operationsDisabled("assets");

  const renderBatchButtons = () => {
    const hiddenAndShownSelected = hiddenSelected && visibleSelected;

    return (
      <>
        {visibility && (
          <Restricted permissions={[RolePermissions.AssetsCreate]}>
            <ToggleVisibilityButton
              onClick={handleToggleVisibility(selectedIds, hiddenSelected)}
              hidden={hiddenSelected}
              isDisabled={hiddenAndShownSelected}
            />
          </Restricted>
        )}
        <Restricted permissions={[RolePermissions.PacksManage, RolePermissions.AssetsCreate]}>
          <AddToPacksButton onClick={togglePackModal} isDisabled={purchasedSelected || draftSelected} />
        </Restricted>
        <Restricted permissions={[RolePermissions.AssetsCreate]}>
          <Tooltip
            hideOnScroll
            content={message}
            position="left center"
            showAlways={purchasedSelected}
            target={
              <DeleteLinkButton
                after={purchasedSelected && <Icon size="large" className="fa fa-exclamation-circle" />}
                isDisabled={purchasedSelected}
                onClick={() => handleDelete(selectedIds)}
              />
            }
          />
        </Restricted>
        <Restricted permissions={[RolePermissions.AssetsCreate]}>
          <TagsManageContainer
            entity="assets"
            isDisabled={purchasedSelected}
            selectedIds={selectedIds}
            onComplete={clearSelection}
          />
        </Restricted>
        <AddAssetsToPackModal
          showModal={packsModalShown}
          onClose={togglePackModal}
          onComplete={props.clearSelection}
          selectedItemIds={selectedIds}
          contentType="Scorm"
        />
      </>
    );
  };

  return (
    <OverviewHeader
      title="SCORM Packages"
      itemName="SCORM Package"
      titleForGA="Assets - SCORM Packages"
      selectedItemsAmount={selectedIds.length}
    >
      <div className={styles.root}>{selectedIds.length ? renderBatchButtons() : <CreateButton />}</div>
    </OverviewHeader>
  );
};
